<svg width="100%" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 3.62003V20.38C4.5 21.658 5.8721 22.4345 6.92878 21.7389L19.7666 13.3589C20.7445 12.728 20.7445 11.272 19.7666 10.6249L6.92878 2.26111C5.8721 1.56548 4.5 2.342 4.5 3.62003Z" fill="currentColor"/>
</svg>
